import React, { useState, useEffect } from 'react';
import { Grid, Box, Link, Typography, IconButton } from '@mui/material';
import CustomTextField from '../../../../components/CustomTextField/CustomTextField';

interface CertificationField {
    certification: string;
}

const CertificationsField = ({ certificationsData, setCertificationsData, setShowIcons }: any) => {
    // State for managing input and list of certifications
    const [certificationInput, setCertificationInput] = useState<string>(''); // Input field value
    const [certificationFields, setCertificationFields] = useState<CertificationField[]>(
        certificationsData?.certifications?.length > 0 ? certificationsData?.certifications : []
    );

    // Update parent state when certificationFields change
    useEffect(() => {
        setCertificationsData({ certifications: certificationFields });

        setShowIcons((prevState: any) => ({
            ...prevState,
            certifications: certificationFields.length > 0, // true if there are degrees, false otherwise
        }));

    }, [certificationFields, setCertificationsData]);

    // Handle input field change
    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setCertificationInput(e.target.value);
    };

    // Add certification to the list and clear the input field
    const addCertificationField = () => {
        if (certificationInput.trim() === '') return; // Do nothing if the input is empty
        setCertificationFields([...certificationFields, { certification: certificationInput }]);
        setCertificationInput(''); // Clear the input field after adding
    };

    // Remove a certification field
    const removeCertificationField = (index: number) => {
        const newCertificationFields = certificationFields.filter((_, i) => i !== index);
        setCertificationFields(newCertificationFields);
    };

    return (
        <Grid display={"flex"} gap={5} flexDirection={"column"} p={{ xs: 2, md: 5 }} mt={{ xs: 3, md: 0 }}>
            <Grid item xs={12} sm={6} display={"flex"} gap={1} flexDirection={"column"}>
                <label htmlFor="certification" style={styleSheet.labelText}>
                    Certifications
                </label>

                {/* Input field to add a new certification */}
                <Grid display={"flex"} alignItems={"center"} flex={1} mb={2}>
                    <Box sx={{ flexGrow: 1, display: "flex", gap: 1, alignItems: "center" }}>
                        <CustomTextField
                            name="certification"
                            type='text'
                            sx={{ width: '100%', maxWidth: '599px' }}
                            value={certificationInput}
                            onChange={handleInputChange} // Handle input change
                        />
                        <Link
                            onClick={addCertificationField}
                            sx={{ width: { xs: "40%", md: "40%" }, color: "#233F91", fontSize: "17px", fontWeight: 400, cursor: 'pointer' }}
                        >
                            Add a Certification
                        </Link>
                    </Box>
                </Grid>

                {/* Render the list of saved certifications */}
                {certificationFields.map((certificate, index) => (
                    <Grid key={index} display={"flex"} alignItems={"center"} flex={1} mb={2}>
                        <Box sx={{ flexGrow: 1, display: "flex", gap: 1, alignItems: "center" }}>
                            <Box sx={{
                                width: "599px", height: "51px", border: "1px solid #C9C9C9",
                                borderRadius: "9px",
                                display: "flex", alignItems: "center",
                            }}>
                                <Typography ml={2} fontSize={"18px"} fontWeight={700} color={"#595959"}>
                                    {certificate.certification}
                                </Typography>
                            </Box>
                            <IconButton onClick={() => removeCertificationField(index)} sx={{ color: "#FF0000" }}>
                                <img src='assets/icons/iconDelete.png' alt='delete' />
                            </IconButton>
                        </Box>
                    </Grid>
                ))}
            </Grid>
        </Grid>
    );
};

export default CertificationsField;

const styleSheet = {
    labelText: {
        fontWeight: 400,
        fontSize: "17px",
        color: "#000000",
    },
};
